module.exports = {
    BACKEND_URL: "https://tipssi.net:8000/api/",
    FRONTEND_URL: "https://f31d-93-185-42-144.ngrok-free.app",
    RECAPTCHA_SITE_KEY: "6LdpNPYpAAAAADmoiSbORUtVi6U80nr3oQu2SH91",
}